import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useDownloadTransactionsStore } from '@lib/store';
import { useAccountContext } from '@shared/hooks';
import { PaletteUtils } from '@shared/utils';
import { TransactionsState } from '@pages';
import { Subheader } from '@widgets';
import { Button, Popup, Spinner } from '@shared/widgets';

interface TransactionsHeaderProps {
  state: TransactionsState;
}

export const TransactionsHeader = (props: TransactionsHeaderProps) => {
  const downloadTransactionsStore = useDownloadTransactionsStore();

  const [isVisible, setIsVisible] = useState<boolean>(false);

  const { account, card } = useAccountContext();
  const { t } = useTranslation('card');

  const handleDownload = async () => {
    if (!account || !card) return;
    const result = await downloadTransactionsStore.downloadTransactions({
      accountId: account.id,
      cardId: card.id,
      From: props.state.dateFrom,
      To: props.state.dateTo,
    });
    if (result.error) setIsVisible(true);
  };

  return (
    <Subheader
      action={
        <div
          className={clsx('align-center cursor-pointer flex py-0  items-center', downloadTransactionsStore.loading && 'pointer-events-none')}
          onClick={handleDownload}
        >
          <span
            className={clsx(
              'text-[14px] font-medium h-[50px] leading-[60px] tracking-[0.2] opacity-100 transition-opacity duration-300 whitespace-nowrap',
              downloadTransactionsStore.loading && 'opacity-20',
            )}
          >
            {t('buttons.download', { ns: 'common' })}
          </span>
          <div className={clsx('opacity-100 mt-2 transition-opacity duration-300', downloadTransactionsStore.loading && 'opacity-20')}>
            <svg className='relative top-0' xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20'>
              <path
                fill={PaletteUtils.isBordierPalette ? '#dc291c' : '#e5c496'}
                fillRule='nonzero'
                d='M10.251 11.463l4.286 4.286a.857.857 0 0 0 1.212 0l4.286-4.286a.857.857 0 0 0-1.213-1.212L16 13.074V4.857a.857.857 0 0 0-1.714 0v8.217l-2.823-2.823a.854.854 0 0 0-1.212 0 .857.857 0 0 0 0 1.212z'
              />
            </svg>
          </div>
          <div className='text-xs min-h-8 h-8 left-1/2 absolute top-1/2 w-8 -mx-4 opacity-0 pointer-events-none transition-all duration-300' />
          {downloadTransactionsStore.loading && <Spinner position />}
          <Popup open={isVisible} onClose={() => setIsVisible(false)}>
            <div className='bg-white absolute left-[50%] text-center -ml-[160px] -mt-[60px] top-[50%] w-[320px]'>
              <div className='border border-[#e1e1e1] p-10'>
                {t('transactions.header.modals.downloadError.description')}
                <div className='flex align-center justify-center mt-[30px] w-full'>
                  <Button
                    className='!font-light border-[#dc291c] hover:bg-[#dc291c] tracking-normal'
                    fullWidth
                    caption={t('buttons.close', { ns: 'common' })}
                    onClick={() => setIsVisible(false)}
                  />
                </div>
              </div>
            </div>
          </Popup>
        </div>
      }
    >
      {t('transactions.header.title')}
    </Subheader>
  );
};
